import { Modal } from '../../Shared/Ant'
import React, { FC, ReactElement, useState } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { GenericProductFormProps, Product } from '../types'
import { ProductFormBody } from '../ProductFormBody/ProductFormBody'
import { apiCall } from '../../../api/apiCall'
import { Requests } from '../../../api/requests'
import { camelCaseToSnakeCase } from '../../../utils/camelCaseToSnakeCase'
import { Provider } from 'react-redux'
import { store, queryClient } from '../../../store'
import '../../Shared/Ant/App.less'

export const AddGenericProduct: FC<GenericProductFormProps> = ({
  allowStateSpecificPricing,
  companyId,
  product,
  ronEnabled,
  ronProviders
}): ReactElement => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  const showModal = () => {
    setIsModalVisible(true)
  }

  const handleCancel = () => {
    setIsModalVisible(false)
  }

  const saveProduct = (
    values: Product,
    showDocumentChecklist: boolean,
    hasSpecialInstructions: boolean,
    showStateSpecificPricing: boolean,
    visibleForAllClients: boolean
  ) => {
    const params = {
      product: values,
      documentChecklistCheckbox: showDocumentChecklist,
      clearSpecialInstructions: !hasSpecialInstructions,
      hasStateSpecificPricing: showStateSpecificPricing,
      visibleForAllClients
    }

    apiCall
      .post(Requests.products(params).path, {
        ...camelCaseToSnakeCase(params)
      })
      .then(() => {
        setIsModalVisible(false)
        window.location.reload()
      })
  }

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <a className="btn btn-primary" onClick={showModal}>
          + Add product
        </a>

        <Modal
          title={'Add a Product'}
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={null}
          className="product-form"
          width={700}
        >
          <ProductFormBody
            allowStateSpecificPricing={allowStateSpecificPricing}
            companyId={companyId}
            product={product}
            submitBtnText={'Create Product'}
            returnChoices={[]}
            fromOrderForm={false}
            saveProduct={saveProduct}
            ronEnabled={ronEnabled}
            ronProviders={ronProviders}
          />
        </Modal>
      </Provider>
    </QueryClientProvider>
  )
}
